import { FC, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { TimerProgressProps } from "./types";
import "./styles.sass";

const TimerProgress: FC<TimerProgressProps> = ({
  duration,
  isProgress,
  isFinished,
  onFinish,
}) => {
  const [active, setActive] = useState(false);
  const refTimer = useRef<ReturnType<typeof setTimeout> | null>();

  useEffect(() => {
    if (isProgress && !isFinished) {
      setActive(true);
      refTimer.current = setTimeout(() => {
        onFinish?.();
      }, duration);
    } else {
      setActive(false);
    }

    return () => {
      if (refTimer.current) {
        clearTimeout(refTimer.current);
        setActive(false);
      }
    };
  }, [duration, isFinished, isProgress, onFinish]);

  const classNameProgress = classNames(
    "TimerProgress__progress",
    active && "TimerProgressActive",
    isFinished && "TimerProgressFinished",
  );

  return (
    <div className="TimerProgress">
      <div
        className={classNameProgress}
        style={{
          animationDuration: `${duration}ms`,
        }}
      />
    </div>
  );
};

export default TimerProgress;
